import React from 'react';
import { Box, Grid } from '@common-fe/common-fe';

const THUMBS_COLUMN_WIDTH = '96px';
const THUMBS_COLUMN_WIDTH_SCROLLABLE = '120px';
const CONTENT_HEIGHT = '453px';

interface Props {
  children: React.ReactNode;
  isSmallViewVersion?: boolean;
  isFlex?: boolean;
  isThumbsTopPosition?: boolean;
  isThumbsScrollable?: boolean;
}

const DropWrapper: React.FC<Props> = ({
  children,
  isSmallViewVersion,
  isFlex,
  isThumbsTopPosition,
  isThumbsScrollable,
}) => {
  if (isSmallViewVersion) {
    return (
      <Box width={isFlex ? '100%' : '324px'} flex={{ grow: 1 }} direction="column-reverse">
        {children}
      </Box>
    );
  }

  if (isThumbsTopPosition) {
    return <Box direction="column">{children}</Box>;
  }

  return (
    <Grid
      columns={[isThumbsScrollable ? THUMBS_COLUMN_WIDTH_SCROLLABLE : THUMBS_COLUMN_WIDTH, 'auto']}
      height={CONTENT_HEIGHT}
      style={{ position: 'relative' }}
    >
      {children}
    </Grid>
  );
};

export default DropWrapper;
